/**
 * Duck referente a Scheduling(Agendamento)
 * @author Otávio Bastilho
 * @copyright 08/2019
 */

import { createActions, createReducer } from "reduxsauce";

//Action types e Creators
export const { Types, Creators } = createActions({
	schedulingSuccess: [],
	schedulingLoading: [],
	schedulingError: [],
	schedulingClean: [],
	idLoad: ["idLoad"],
	selectDate: ["date"],
	selectHour: ["hour"],
	selectGate: ["gate"],
	clearHour: [],
	clearGate: [],
	setLoadingSchedulingReport: [],
	setCsvSchedulingReport: []
});

//Reducer Handlers
const INITIAL_STATE = {
	idLoad: '',
	date: '',
	hour: '',
	gate: undefined,
	loading: false,
	error: undefined,
	scheduling: undefined,
	schedulingError:null,
	schedulingSuccess:null,
	isLoadingSchedulingReport: false,
	csvReportData: []
}

const idLoad = (state = INITIAL_STATE, action) => {
	return {...state, idLoad : action.idLoad}
}

const date = (state = INITIAL_STATE, action) => {
	return {...state, date : action.date}
}

const hour = (state = INITIAL_STATE, action) => {
	return {...state, hour : action.hour}
}

const gate = (state = INITIAL_STATE, action) => {
	return {...state, gate : action.gate}
}

const clearHour = (state = INITIAL_STATE, action) => {
	return {...state, hour : ''}
}

const clearGate = (state = INITIAL_STATE, action) => {
	return {...state, gate: ''}
}

const schedulingSuccess = (state = INITIAL_STATE, action) => {
	return {...state, loading: false, error: undefined, scheduling: true, schedulingSuccess:{...action.payload}}
}

const schedulingLoading = (state = INITIAL_STATE, action) => {
	return {...state, loading: true, error: undefined, scheduling: undefined}
}

const schedulingError = (state = INITIAL_STATE, action) => {
	return {...state, loading: false, error: action, scheduling: false, schedulingError:{...action.payload}}
}

const schedulingClean = (state = INITIAL_STATE, action) => {
	return {...INITIAL_STATE}
}

const setLoadingSchedulingReport = (state = INITIAL_STATE, action) => {
	return {...state, isLoadingSchedulingReport: action.payload }
}

const setCsvSchedulingReport = (state = INITIAL_STATE, action) => {
	return {...state, csvReportData: action.payload }
}

//Criando Reducer
export default createReducer(INITIAL_STATE, {
	[Types.SCHEDULING_SUCCESS]: schedulingSuccess,
	[Types.SCHEDULING_LOADING]: schedulingLoading,
	[Types.SCHEDULING_ERROR]: schedulingError,
	[Types.SCHEDULING_CLEAN]: schedulingClean,
	[Types.ID_LOAD]: idLoad,
	[Types.SELECT_DATE]: date,
	[Types.SELECT_HOUR]: hour,
	[Types.SELECT_GATE]: gate,
	[Types.CLEAR_HOUR] : clearHour,
	[Types.CLEAR_GATE] : clearGate,
	[Types.SET_LOADING_SCHEDULING_REPORT] : setLoadingSchedulingReport,
	[Types.SET_CSV_SCHEDULING_REPORT] : setCsvSchedulingReport,
});
